<template>
    <o-field v-if="(!to && !href) || loading" :label="label" class="info-tile">
        <template v-if="!loading">
            <p v-if="html" v-html="html" style="width: 100%"></p>
            <p v-else-if="value">
                <o-icon v-if="icon" :icon="icon" pack="fab" size="medium"></o-icon>
                {{ prefix }}{{ value }}
            </p>
            <p v-if="value2">
                <o-icon v-if="icon2" :icon="icon2" pack="fab" size="medium"></o-icon>
                {{ prefix2 }}{{ value2 }}
            </p>
            <p v-if="!value && !value2 && !html" class="empty"></p>
        </template>
        <o-skeleton width="66%" v-else></o-skeleton>
    </o-field>
    <div v-else-if="to" class="field info-tile">
        <label class="label">{{ label }}</label>
        <a v-if="isToSpecial" :href="to">
            <p v-if="html" v-html="html"></p>
            <p v-else-if="value">
                <o-icon v-if="icon" :icon="icon" pack="fab" size="medium"></o-icon>
                {{ prefix }}{{ value }}
            </p>
            <p v-if="value2">
                <o-icon v-if="icon2" :icon="icon2" pack="fab" size="medium"></o-icon>
                {{ prefix2 }}{{ value2 }}
            </p>
        </a>
        <router-link v-else :to="to">
            <p v-if="html" v-html="html"></p>
            <p v-else-if="value">
                <o-icon v-if="icon" :icon="icon" pack="fab" size="medium"></o-icon>
                {{ prefix }}{{ value }}
            </p>
            <p v-if="value2">
                <o-icon v-if="icon2" :icon="icon2" pack="fab" size="medium"></o-icon>
                {{ prefix2 }}{{ value2 }}
            </p>
        </router-link>
    </div>
    <div v-else-if="href && href2" class="field info-tile" target="_blank">
        <label class="label">{{ label }}</label>
        <p v-if="html" v-html="html"></p>
        <a v-else-if="value" :href="href">
            <o-icon v-if="icon" :icon="icon" pack="fab" size="medium"></o-icon>
            {{ prefix }}{{ value }}
        </a>
        <br />
        <a v-if="value2" :href="href2">
            <o-icon v-if="icon2" :icon="icon2" pack="fab" size="medium"></o-icon>
            {{ prefix2 }}{{ value2 }}
        </a>
    </div>
    <a v-else-if="label === 'Contact'" class="field info-tile" target="_blank" :href="href">
        <label class="label">{{ label }}</label>
        <p v-if="html" v-html="html"></p>
        <p v-else-if="value">
            <o-icon v-if="icon" :icon="icon" pack="fab" size="medium"></o-icon>
            {{ prefix }}{{ value }}
        </p>
        <p v-if="value2">
            <o-icon v-if="icon2" :icon="icon2" pack="fab" size="medium"></o-icon>
            {{ prefix2 }}{{ value2 }}
        </p>
    </a>
    <a v-else-if="href" class="field info-tile" target="_blank" :href="$filters.WebAddress(href)">
        <label class="label">{{ label }}</label>
        <p v-if="html" v-html="html"></p>
        <p v-else-if="value">
            <o-icon v-if="icon" :icon="icon" pack="fab" size="medium"></o-icon>
            {{ prefix }}{{ value }}
        </p>
        <p v-if="value2">
            <o-icon v-if="icon2" :icon="icon2" pack="fab" size="medium"></o-icon>
            {{ prefix2 }}{{ value2 }}
        </p>
    </a>
</template>
<script>
import { ref, computed, inject, onMounted, onUnmounted } from "vue";
export default {
    props: {
        label: {
            type: String,
            default: ""
        },
        value: {
            type: String,
            default: ""
        },
        value2: {
            type: String,
            default: ""
        },
        prefix: {
            type: String,
            default: ""
        },
        prefix2: {
            type: String,
            default: ""
        },
        icon: {
            type: String,
            default: ""
        },
        icon2: {
            type: String,
            default: ""
        },
        to: {
            type: [Object, String, null],
            default: null
        },
        href: {
            type: String,
            default: ""
        },
        href2: {
            type: String,
            default: ""
        },
        loading: {
            type: Boolean,
            default: false
        },
        html: {
            type: String,
            default: ""
        }
    },
    setup(props, context) {
        const isToSpecial = computed(() => {
            return (
                props.to &&
                typeof props.to === "string" &&
                (props.to.startsWith("mailto:") || props.to.startsWith("tel:"))
            );
        });

        return {
            isToSpecial
        };
    }
};
</script>
